import React, {useState, useContext} from 'react';
import{Button, Col, Form, Input, Modal, Row} from 'antd';
import Colors from "../../../styles/Colors";
import {BiCheck, BiX} from "react-icons/bi";
import {AuthContext} from "../../../config/AuthContext";
import {PostEmpresa} from "../../../dao/admin/PostEmpresa";

interface EmpresaModalProps{
    element: Object;
    visible: boolean;
    onClose: (value: boolean) => void;
}

const EmpresaModal: React.FC<EmpresaModalProps> = ({element, visible, onClose}) => {
    const [form] = Form.useForm();
    const {isLoggedIn, userId, user, page} = useContext(AuthContext);

    async function handleCancel() {
        onClose(false); 
    };

    async function handleSubmit() {
        const fromData = form.getFieldsValue();
        await PostEmpresa(page, fromData, userId);
        onClose(true);
    };

    return(
        <Modal
            title="Crear/Editar Empresa"
            open={visible}
            onCancel={handleCancel}
            footer={[
                <>
                    <Button title={"Acceptar"} style={{backgroundColor: Colors.colors.color6}}
                            onClick={handleSubmit}><BiCheck/></Button>
                    {" "}
                    <Button title={"Cancelar"} style={{backgroundColor: Colors.colors.color1}}
                            onClick={handleCancel}><BiX/></Button>
                </>
            ]}
            width={1000}
        >
            <Form form={form} initialValues={element}>
                <br/>
                <Row gutter={[16,16]}>
                    <Col span={12}>
                        <Form.Item label="id" name="id">
                            <Input type="text" disabled={true}/>
                        </Form.Item>

                        <Form.Item label="Nom" name="nomEmpresa" 
                            rules={[{ required: true, message: 'Introdueix el nom d\'empresa' }]}>
                        <Input type="text" />
                        </Form.Item>

                        <Form.Item label="Adreça" name="direccio"
                            rules={[{ required: true, message: 'Introdueix la adreça d\'empresa' }]}>
                            <Input type="text" />
                        </Form.Item>

                        <Form.Item label="Correu" name="correu"
                            rules={[{ required: true, message: 'Introdueix el correu d\'empresa' }]}>
                            <Input type="text" />
                        </Form.Item>
                        
                    </Col>
                     <Col span={12}>
                     <Form.Item label="ID empresa" name="idEmpresa"
                            rules={[{ required: true, message: 'Introdueix el ID d\'empresa' }]}>
                            <Input type="text" />
                        </Form.Item>
                        
                        <Form.Item label="IBAN" name="iban"
                            rules={[{ required: true, message: 'Introdueix el IBAN d\'empresa' }]}>
                            <Input type="text" />
                        </Form.Item>

                        <Form.Item label="SEPA" name="sepa"
                            rules={[{ required: true, message: 'Introdueix la SEPA d\'empresa' }]}>
                            <Input type="text" />
                        </Form.Item>

                        <Form.Item label="NIF" name="nif"
                            rules={[{ required: true, message: 'Introdueix el NIF d\'empresa' }]}>
                            <Input type="text" />
                        </Form.Item>
                    </Col>

                </Row>
            </Form>
        </Modal>

    );
};
export default EmpresaModal;
